import styles from '../../../pages/Badging/AdminPrint/AdminPrint.module.css'
// components
import { AsyncPaginate } from 'react-select-async-paginate';

const RegistrantName = ({ loadOptions, onChange, onInputChange, regError }) => {

    return (
        <div className={styles.dropdownContainer}>
            <AsyncPaginate
                //value={searchTerm} // don't use with loadOptions, one or other
                loadOptions={loadOptions}//activates selections
                //getOptionValue={option => option.value}
                //getOptionLabel={option => option.label}
                onInputChange={onInputChange} // detects typing entry
                onChange={onChange} // option selected
                isClearable={true}
                isSearchable={true}
                placeholder={'Enter Name'}
                debounceTimeout={300}
            /*additional={{
                page: 0,
            }}*/
            />
            {regError && regError.length > 0 ?
                <div style={{ color: 'red' }}>
                    <br />
                    Error: {regError}
                </div>

                : <></>
            }
        </div>
    );
}

export default RegistrantName;